import React from "react";
import { Button } from "wbm-inputs";

type HeaderProps = {
  header: string;
  link?: boolean;
  linkText?: string;
  clickAction?: any;
};

export const ModalSliderSectionHeader = ({ ...props }: HeaderProps) => {
  return (
    <div className="modal-slider-section-header">
      <span className="font-weight-bold">{props.header}</span>
      {props.link ? (
        <Button className="btn-link medium" onClick={() => props.clickAction()}>
          {props.linkText}
        </Button>
      ) : null}
    </div>
  );
};
